webpackJsonp([265136788301617],{

/***/ 472:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Nick Long's Blog","subtitle":"Engineer & Musician","copyright":"© Nick Long 2018 All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"About me","path":"/about/"}],"author":{"name":"Nick Long","email":"#","telegram":"#","twitter":"monquixote","github":"monquixote","rss":"./rss.xml","vk":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/fret-king-vs-tonerider-vs-iron-gear-part-2/","categorySlug":"/categories/guitar/"},"frontmatter":{"title":"Fret King Vs Tonerider (Vs Iron Gear) - Part 2","date":"2011-06-20T22:23:00.000Z","category":"guitar","description":null}}}]}},"pathContext":{"category":"guitar"}}

/***/ })

});


// WEBPACK FOOTER //
// path---categories-guitar-19a0fe3de6181ad876f7.js